import http from '@/utils/http'
import service from '@/http/service'

export default {
  url: `${service.merchant}/submit`,
  // 分页查询
  getListByPage(params) {
    return http.get(`${this.url}/own_list`, params)
  },
  deleteByIds(ids) {
    return http.delete(`${this.url}/delete/${ids}`)
  },
  // 结算资料保存
  saveData(data) {
    return http.post(`${this.url}/save`, data)
  },
  // 结算资料提交保存
  submitData(data) {
    return http.post(`${this.url}/submit`, data)
  },
  // 结算资料修改提交记录
  updateData(data) {
    return http.put(`${this.url}/update`, data)
  },
  // 查询结算审批记录
  getReplyList(id) {
    return http.get(`${this.url}/replyList/${id}`)
  },
  // 获取同步配置信息
  querySyncConfig(params) {
    return http.get(`${this.url}/querySyncConfig`, params)
  },
  // 核验专普票并存储到票夹
  verificationTicket(data) {
    return http.post(`${this.url}/verificationTicket`, data)
  }
}
